import { FETCH_STATIONS, FETCH_STATION } from '@actions'
import { updateField } from '../helpers'
import { StationsService } from '@common/ApiService'
import paginationHeaders from '@/src/utils/pagination-headers'

const UPDATE_STATIONS = 'STATIONS_SUCCESS'
const UPDATE_STATION = 'STATION_SUCCESS'
const FETCH_ERROR = 'FETCH_ERROR'
const UPDATE_PROGRESS = 'UPDATE_PROGRESS'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
const DEFAULT_SCHEDULED_EMAIL = {
  active: false,
  report_period: '',
  report_time: '0000',
  report_time_offset: '',
  recipients: '',
  fax: '',
}

export const state = {
  stations: [],
  pagination: {},
  station: {
    name: '',
    crs_code: '',
    toc: '',
    hub_station: {
      id: '',
      name: '',
    },
    electronic_handover: 'disabled',
    send_reports_to_hub: false,
    station_type: '',
    scheduled_email: {},
  },
  errors: {},
  progress: '',
}

export const getters = {}

export const mutations = {
  updateField,

  [UPDATE_STATIONS](state, payload) {
    state.stations = payload
    state.progress = 'success'
    return state
  },

  [UPDATE_PAGINATION](state, response) {
    state.pagination = paginationHeaders(response)
    return state
  },

  [UPDATE_STATION](state, data) {
    state.station = data
    if (!data.scheduled_email) {
      state.station.scheduled_email = DEFAULT_SCHEDULED_EMAIL
    }
    state.progress = 'success'
    return state
  },

  [FETCH_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state.errors
  },

  [UPDATE_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },
}

export const actions = {
  [FETCH_STATIONS]({ commit }, query) {
    commit(UPDATE_PROGRESS, 'search_loading')
    if (!query) {
      query = {}
    }

    if (!query.q || query.q === '') {
      query.per_page = 13
    } else {
      query.per_page = 25
    }

    return StationsService.query(query)
      .then((response) => {
        commit(UPDATE_STATIONS, response.data)
        commit(UPDATE_PAGINATION, response)
      })
      .catch((error) => commit(FETCH_ERROR, error))
  },

  fetchStationsWithDetails({ commit }, query) {
    return new Promise((resolve) => {
      commit(UPDATE_PROGRESS, 'search_loading')
      return StationsService.index(query)
        .then((response) => {
          commit(UPDATE_STATIONS, response.data)
          commit(UPDATE_PAGINATION, response)
          commit(UPDATE_PROGRESS, 'stations_success')
          resolve(response.data)
        })
        .catch((error) => commit(FETCH_ERROR, error))
    })
  },

  [FETCH_STATION]({ commit }, crsCode) {
    commit(UPDATE_PROGRESS, 'search_loading')
    return new Promise((resolve, reject) => {
      StationsService.get(crsCode)
        .then((response) => {
          commit(UPDATE_STATION, response.data)
          resolve(response.data)
        })
        .catch((error) => {
          commit(FETCH_ERROR, error)
          reject(error)
        })
    })
  },

  updateStation({ commit }, station) {
    commit(UPDATE_PROGRESS, 'search_loading')
    return StationsService.update(station.crs_code, {
      ...station,
    })
      .then((response) => {
        commit(UPDATE_STATION, response.data)
        if (response.status === 200) {
          commit(FETCH_ERROR, null)
        }
      })
      .catch((error) => commit(FETCH_ERROR, error))
  },

  clearAll({ commit }) {
    commit(UPDATE_STATIONS, [])
  },

  filterStations({ commit }, params) {
    commit(UPDATE_PROGRESS, 'search_loading')

    return new Promise((resolve, reject) => {
      StationsService.queryStation(params)
        .then((response) => {
          commit(UPDATE_STATIONS, response.data)
          resolve(response.data)
        })
        .catch((error) => {
          commit(FETCH_ERROR, error)
          reject(error)
        })
    })
  },
}
